import { render } from "./ImagesColumns.vue?vue&type=template&id=1997a53a"
import script from "./ImagesColumns.vue?vue&type=script&lang=js"
export * from "./ImagesColumns.vue?vue&type=script&lang=js"

import "./ImagesColumns.vue?vue&type=style&index=0&id=1997a53a&lang=scss"
script.render = render

export default script